import styled from 'styled-components';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core';


export const PhoneNumbersManagerContainer = styled.div`
	display: flex;
	flex-direction: column;
  align-items: start;
	height: 100%;
	width: 100%;
	background-color: #f0f2f5;
  padding: 20px 80px;
`;

export const HeaderContainer = styled.div`
  padding: 16px 0;
  padding-bottom: 0px;
`;

export const MainTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
`;
export const PhoneNumbersContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  width: 840px;
  overflow-y: auto;
`;

export const TitleContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
`;
export const ButtonAddPhoneNumber = styled.button`
    border: none;
    cursor: pointer;
    background-color: transparent;

    &:disabled {
        cursor: no-drop;
        opacity: 0.5;
    }
`;

export const PhoneNumbersTable = styled.table`
    display: table;
    width: 100%;
    border-collapse: collapse;
`;
export const PhoneNumbersTableHead = styled.thead`
  display: table-header-group;
`;
export const PhoneNumbersHeaderContainer = styled.tr`
  display: grid;
  grid-template-columns: 1.5fr 1.2fr 0.8fr 1fr 1.2fr;
  align-items: center;
  padding: 5px 10px;
  width: 100%;
  gap: 10px;
`;
export const PhoneNumbersHeaderItem = styled.th`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
`;
export const PhoneNumbersTableBody = styled.tbody`
  display: table-row-group;
`;
export const PhoneNumbersItem = styled.tr`
  display: grid;
  grid-template-columns: 1.5fr 1.2fr 0.8fr 1fr 1.2fr;
  align-items: center;
  padding: 5px 10px;
  width: 100%;
  gap: 10px;
  border-top: 1px solid #e0e0e0;
`;
export const PhoneNumbersItemTitle = styled.td`
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
`;
export const PhoneNumbersItemActions = styled.td`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const GreenSwitch = withStyles( {
	switchBase: {
		color       : '#00a884',
		'&$checked' : {
			color: '#00a884'
		},
		'&$checked + $track': {
			backgroundColor: '#00a884'
		}
	},
	checked : {},
	track   : {},
} )( Switch );

export const PhoneNumbersLoading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;